<template>
  <div
    class="el-select indiction-select tag-no-wrap"
    :class="{ 'tag-focus': selectHoverFocus }"
    style="width:100%"
    @click="openDialog"
    @mouseenter="inputHovering = true"
    @mouseleave="inputHovering = false">
    <div
      v-if="multiple"
      ref="tags"
      class="el-select__tags"
      style="width: calc(100% - 35px)">
      <span v-if="collapseTags && selectedValue.length > 1">
        <el-tag
          :size="collapseTagSize"
          :title="selectedValue[0].text"
          type="info"
          closable
          @close="deleteTag($event, selectedValue[0], 0)"
          disable-transitions>
          <span class="el-select__tags-text">{{ selectedValue[0].text }}</span>
        </el-tag>
        <el-tag
          slot="reference"
          :closable="false"
          :size="collapseTagSize"
          type="info"
          disable-transitions
          @mouseenter.native="collapseTagMouseenter">
          <span class="el-select__tags-text">+ {{ selectedValue.length - 1 }}</span>
        </el-tag>
      </span>
      <transition-group v-else @after-leave="resetInputHeight">
        <el-tag
          v-for="(item, i) in selectedValue"
          :key="item.value"
          :size="collapseTagSize"
          :title="item.text"
          type="info"
          closable
          @close="deleteTag($event, item, i)"
          disable-transitions>
          <span class="el-select__tags-text">{{ item.text }}</span>
        </el-tag>
      </transition-group>
    </div>
    <el-input
      ref="reference"
      :value="selectedValue.text"
      :validate-event="false"
      :class="{ 'is-focus': visible }"
      :tabindex="multiple ? '-1' : null"
      :placeholder="values.length > 0 ? '' : '请选择'"
      type="text"
      readonly>
      <template slot="prefix" v-if="$slots.prefix">
        <slot name="prefix"></slot>
      </template>
      <template slot="suffix">
        <i v-if="showCloseCopy" class="el-select__caret el-input__icon el-icon-circle-close is-reverse" @click.stop="handleClearClick"></i>
        <i v-else class="el-select__caret el-input__icon el-icon-search is-reverse"></i>
      </template>
    </el-input>
    <div
      ref="selectHover"
      v-if="!isDesign"
      v-show="selectedValue.length > 1"
      class="indiction-select-hover"
      :style="selectHoverStyle"
      tabindex="0"
      hidefocus="true"
      @focus="selectHoverFocus = true"
      @blur="selectHoverFocus = false">
      <el-tag
        v-for="(item, i) in selectedValue"
        :key="item.value"
        :title="item.text"
        v-show="i"
        type="info"
        size="small"
        closable
        disable-transitions
        @click.native.stop="$selectHover.focus()"
        @close="deleteTag($event, item, i)">
        <span class="el-select__tags-text">{{ item.text }}</span>
      </el-tag>
    </div>
  </div>
</template>

<script>
export default {
  name: "DsfSuperSearchDataChoice",
  inject: {
    $vm: {
      default: null
    }
  },
  props: {
    collapseTags: {
      type: Boolean,
      default: true,
    },
    size: String,
    isDesign: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    values: {
      type: [String, Array, Object],
      default() {
        return [];
      },
    },
    item: {
      type: Object,
      default() {
        return {};
      }
    },
  },
  data() {
    return {
      visible: false,
      inputHovering: false,
      selectHoverStyle: {},
      selectHoverFocus: false,
    }
  },
  computed: {
    selectedValue() {
      let val = this.values;
      if (this.multiple) {
        return dsf.isObject(val) ? [val] : dsf.isArray(val) ? val : [];
      }
      return dsf.isObject(val) ? val : dsf.isArray(val) && val.length ? val[0] : {text: '', value: ''};
    },
    showCloseCopy() {
      if (this.item.isClearable === false) return false;
      if (!this.inputHovering) return false;
      if (this.multiple) {
        return this.selectedValue.length > 0
      }
      return !!this.selectedValue?.value;
    },
    collapseTagSize() {
      return ['small', 'mini'].indexOf(this.size) > -1
        ? 'mini'
        : 'small';
    },
  },
  mounted() {
    if (!this.isDesign && this.multiple) {
      this.$selectHover = this.$refs.selectHover;
      document.body.appendChild(this.$selectHover);
      this.updateStyle();
      this.$scrollRoot = dsf.findScrollEl(this.$el);
      this.$scrollRoot.addEventListener("scroll", this.updateStyle);
      window.addEventListener("resize", this.updateStyle);
    }
  },
  beforeDestroy() {
    if (!this.isDesign && this.multipe) {
      window.removeEventListener("resize", this.updateStyle);
      this.$scrollRoot.removeEventListener("scroll", this.updateStyle);
      $(this.$selectHover).remove()
    }
  },
  methods: {
    resetInputHeight() {},
    openDialog() {
      let {value: dialog = {}} = this.item.valueSource;
      let {title, width, height, url} = dialog;
      this.$openDialog({
        title: title || '请选择',
        width: width || '800px',
        height: height || '500px',
        top: "10vh",
        params: {
          //标记一下当前页面来自于数据选择
          fromDataChioce: true,
          //页面路径
          path: this.$replace(url, this.$vm),
          //数据选择的值
          choiceParams: {
            value: this.values,
            maxTags: this.multiple ? 0 : 1
          },
          selectValue: this.values
        },
        btns: [
          {
            text: "确定",
            handler: res => {
              if (res.content) {
                let vm = res.content;
                if (vm && vm.yes && dsf.isFunction(vm.yes)) {
                  let returnValue = vm.yes();
                  if (!returnValue) {
                    return false;
                  } else {
                    returnValue = JSON.parse(JSON.stringify(returnValue));
                    let result = this.mapData(returnValue);
                    if (!this.multiple && result.length > 1) {
                      result = [result.pop()];
                    }
                    this.$emit("update:values", result);
                    this.$nextTick(() => {
                      this.$emit("change");
                    });
                  }
                }
              }
            }
          },
          {
            text: "取消"
          }
        ]
      });
    },
    mapData(result) {
      let arr = dsf.type(result) == "array" ? result : [result];
      //默认取字段名称name、_id作为组件的text、value;
      let list = [];
      for (let i = 0; i < arr.length; i++) {
        let r = arr[i];
        let value = this.autoMapDataText(r);
        if (value) {
          list.push(value);
        }
      }
      return list;
    },
    autoMapDataText(data) {
      let rmetakey = /(\w+)\.(\w+)/g;
      //默认检测text 和 name作为text属性
      //默认检测_id 和 value作为value属性
      let commonTextKeys = ["text", "_text", "name", "_name", "label", "_label"];
      let commonValueKeys = ["value", "_value", "id", "_id", "key", "_key"];
      let result = null;
      let text, value;
      for (let k in data) {
        let key = k;
        rmetakey.lastIndex = 0;
        let match = rmetakey.exec(k);
        if (match && match[2]) {
          key = match[2];
        }
        if (this.dialogTextKey && (key == this.dialogTextKey || k == this.dialogTextKey)) {
          text = data[k];
        }
        if (this.dialogValueKey && (key == this.dialogValueKey || k == this.dialogValueKey)) {
          value = data[k];
        }
        if (dsf.isUnDef(text) && commonTextKeys.indexOf(key) >= 0) {
          text = data[k];
        }
        if (dsf.isUnDef(value) && commonValueKeys.indexOf(key) >= 0) {
          value = data[k];
        }
      }

      if (dsf.isDef(text) || dsf.isDef(value)) {
        result = {
          text: text,
          value: value
        };
      }
      return result;
    },
    handleClearClick() {
      this.$emit("update:values", []);
      this.$nextTick(() => {
        this.$emit("change");
      });
    },
    deleteTag(e, item, index) {
      this.values.splice(index, 1);
      this.$nextTick(() => {
        this.$emit("change");
      });
    },
    updateStyle() {
      let rect = this.$el.getClientRects()[0];
      if (rect) {
        this.selectHoverStyle = {
          width: rect.width + "px",
          top: rect.top + rect.height + 11 + "px",
          left: rect.left + "px",
        };
      }
    },
    collapseTagMouseenter() {
      if (this.values.length > 1) {
        this.$selectHover.focus();
      }
    }
  }
}
</script>